<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="_moreCondition()">
          {{ housekeepingDispatchManageInfo.moreCondition == true ? '隐藏' : '更多' }}
        </el-button>
      </div>
      <div class="">
        <el-form :inline="true" :model="housekeepingDispatchManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input placeholder="请输入工单编号" v-model="housekeepingDispatchManageInfo.conditions.cartId">
              </el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input placeholder="请输入申请人" v-model="housekeepingDispatchManageInfo.conditions.applyName">
              </el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input placeholder="请输入联系电话" v-model="housekeepingDispatchManageInfo.conditions.applyTel">
              </el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryHousekeepingPoolMethod()">
              <i class="el-icon-search"></i> 查询
            </el-button>
            <el-button type="primary" size="small" @click="_resetHousekeepingPoolMethod()">
              <i class="el-icon-refresh"></i> 重置
            </el-button>
          </el-form-item>
        </el-form>
        <el-form :inline="true" :model="housekeepingDispatchManageInfo.conditions" class="flex justify-start"
          v-if="housekeepingDispatchManageInfo.moreCondition == true">
          <el-form-item>
            <el-select v-model="housekeepingDispatchManageInfo.conditions.state" placeholder="请选择状态" style="width:100%">
              <el-option disabled value="" label="请选择状态">
              </el-option>
              <el-option v-for="(item, index) in housekeepingDispatchManageInfo.states" :key="index" :label="item.name"
                :value="item.statusCd">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ housekeepingDispatchManageInfo.conditions.roomName }}服务待办</span>
      </div>
      <div class="card-body">
        <el-table :data="housekeepingDispatchManageInfo.pools" style="width: 100%" border>
          <el-table-column prop="servName" label="服务名称" align="center">
          </el-table-column>
          <el-table-column prop="cartId" label="订单编号" align="center">
          </el-table-column>
          <el-table-column prop="applyName" label="申请人" align="center">
          </el-table-column>
          <el-table-column prop="applyTel" label="联系方式" align="center">
          </el-table-column>
          <el-table-column prop="appointmentTime" label="预约时间" align="center">
          </el-table-column>
          <el-table-column prop="stateName" label="状态" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.state == '1800' && (scope.row.returnVisitFlag == '001' || scope.row.returnVisitFlag == '002')">
                {{ scope.row.stateName }}(定时任务处理)
              </span>
              <span v-else>
                {{ scope.row.stateName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button-group>
                <el-button v-if="scope.row.state == '1100' || scope.row.state == '1200' || scope.row.state == '1300'"
                  size="mini" @click="_openDispatchRepairModel(scope.row)">
                  转单
                </el-button>
                <el-button v-if="scope.row.preStaffId != '-1' && scope.row.ruId != scope.row.preRuId" size="mini"
                  @click="_openBackRepairModel(scope.row)">
                  退单
                </el-button>
                <el-button v-if="scope.row.state == '1100' || scope.row.state == '1200' || scope.row.state == '1300'"
                  size="mini" @click="_openFinishRepair(scope.row)">
                  办结
                </el-button>
                <el-button
                  v-if="hasPrivilege('502021040151320003') && scope.row.state == '1800' && scope.row.returnVisitFlag == '003'"
                  size="mini" @click="_openAppraiseRepair(scope.row)">
                  回访
                </el-button>
                <el-button size="mini" @click="_openDetail(scope.row)">
                  详情
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          :total="total" layout="total, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </el-card>

    <dispatch-housekeeping ref="dispatchHousekeeping"></dispatch-housekeeping>
    <appraise-housekeeping ref="appraiseHousekeeping"></appraise-housekeeping>
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryStaffServ } from '@/api/housekeeping/housekeepingDispatchManageApi'

export default {
  name: 'HousekeepingDispatchManage',
  components: {
    'dispatch-housekeeping': () => import('@/components/goods/dispatchHousekeeping/dispatchHousekeeping.vue'),
    'appraise-housekeeping': () => import('@/components/goods/appraiseHousekeeping/appraiseHousekeeping.vue')
  },
  data() {
    return {
      housekeepingDispatchManageInfo: {
        pools: [],
        total: 0,
        records: 1,
        moreCondition: false,
        states: [],
        conditions: {
          cartId: '',
          applyName: '',
          applyTel: '',
          repairType: '',
          roomId: '',
          roomName: '',
          ownerId: '',
          state: '',
          page: 1,
          row: 10,
          shopId: ''
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listHousekeepingPools(1, 10)
    this.getDictData()
  },
  methods: {
    async getDictData() {
      try {
        const {data} = await getDict('housekeeping_serv_pool', 'state')
        this.housekeepingDispatchManageInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listHousekeepingPools(page, rows) {
      this.housekeepingDispatchManageInfo.conditions.page = page
      this.housekeepingDispatchManageInfo.conditions.row = rows
      this.housekeepingDispatchManageInfo.conditions.shopId = getShopId()

      const params = {
        ...this.housekeepingDispatchManageInfo.conditions,
        cartId: this.housekeepingDispatchManageInfo.conditions.cartId.trim(),
        applyName: this.housekeepingDispatchManageInfo.conditions.applyName.trim(),
        applyTel: this.housekeepingDispatchManageInfo.conditions.applyTel.trim(),
        state: this.housekeepingDispatchManageInfo.conditions.state.trim()
      }

      try {
        const res = await queryStaffServ(params)
        this.housekeepingDispatchManageInfo.total = res.total
        this.housekeepingDispatchManageInfo.records = res.records
        this.housekeepingDispatchManageInfo.pools = res.data
        this.currentPage = page
        console.log(this.housekeepingDispatchManageInfo.records)
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryHousekeepingPoolMethod() {
      this._listHousekeepingPools(1, 10)
    },
    _resetHousekeepingPoolMethod() {
      this.housekeepingDispatchManageInfo.conditions = {
        cartId: '',
        applyName: '',
        applyTel: '',
        state: '',
        page: 1,
        row: 10,
        shopId: getShopId()
      }
      this._listHousekeepingPools(1, 10)
    },
    _openFinishRepair(pool) {
      this.$router.push(`/pages/goods/finishHousekeepingPool?poolId=${pool.poolId}&servId=${pool.servId}`)
    },
    _moreCondition() {
      this.housekeepingDispatchManageInfo.moreCondition = !this.housekeepingDispatchManageInfo.moreCondition
    },
    _openDispatchRepairModel(pool) {
      pool.action = "TRANSFER"
      this.$refs.dispatchHousekeeping.open(pool)
    },
    _openBackRepairModel(pool) {
      pool.action = "BACK"
      this.$refs.dispatchHousekeeping.open(pool)
    },
    _openAppraiseRepair(pool) {
      this.$refs.appraiseHousekeeping.open(pool)
    },
    _openDetail(pool) {
      this.$router.push(`/pages/housekeeping/housekeepingServDetail?poolId=${pool.poolId}&servId=${pool.servId}`)
    },
    handleCurrentChange(val) {
      this._listHousekeepingPools(val, 10)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.card-body {
  padding: 20px;
}
</style>